import React, { createContext, ReactChild, ReactChildren, useContext, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { IPaymentPartner, PHONE_STATUS } from './payements/common';

import "./i18n";
import Checkout from './sample/Checkout';
import SystemMessage from './system.message/system.message';
import { AxiosInterceptor } from './axios.setup';
import SuccessPage from './sample/Success';
import FailurePage from './sample/Failure';
import { env } from 'process';
import PaymentStatus from './payements/payement.status/payment.status';
// Context API

interface IItem { value: string; error: string; }

export interface IQuestionnaire {
  question: string;
  answer: string;
}

export interface ILayout {
  bottomLogo: string;
  bottomMessage: string;
  contactUsURL: string;
  greetings: string;
  poweredBy: string;
  poweredByURL: string;
  questionnaire: IQuestionnaire[];
  topRightLogo: string;
  topLeftLogo: string;
}
export interface IPaymentDetail {
  id?: string;
  vendorName: string;
  vendorId: string;
  appName?: string;
  cart: ICart | null;
  amount: string;
  source?: string;
  currency?: string;
  redirectSuccessURL?: string;
  redirectFailURL?: string;
  externalId?: string;
  language?: string;
  logoUrl?: string;
}

export interface ICartItem {
  name: string
}
export interface ICart {
  items: ICartItem[];
}
interface IPaymentState {
  mode: string;
  loading: boolean;
  success: boolean;
  steps: number[];
  stepIndex: number;
  paymentDetail: IPaymentDetail | null;
  phone: IItem;
  pin: IItem;
  phoneStatus: string;
  approveInApp: boolean;
  paymentPartners: IPaymentPartner[];
  layout: ILayout;
  status: string;
  statusAttempt: number;
  systemMessage: {
    show: boolean; type?: string; title?: string; message: string;
  }
}

const PaymentState: IPaymentState = {
  mode: "",
  loading: true,
  success: false,
  steps: [1, 2],
  stepIndex: 0,
  paymentDetail: null,
  phone: { value: "", error: "" },
  pin: { value: "", error: "" },
  phoneStatus: PHONE_STATUS.PHONE_REQUIRED,
  approveInApp: false,
  paymentPartners: [],
  layout: {
    bottomLogo: "",
    bottomMessage: "",
    contactUsURL: "",
    greetings: "",
    poweredBy: "",
    poweredByURL: "",
    questionnaire: [],
    topRightLogo: "",
    topLeftLogo: "",
  },
  status: "pending",
  statusAttempt: 0,
  systemMessage: {
    show: false, type: "error", title: "", message: ""
  }
}

export function createCtx<A>(defaultValue: A) {
  type UpdateType = React.Dispatch<
    React.SetStateAction<typeof defaultValue>
  >;
  const defaultUpdate: UpdateType = () => defaultValue;
  const ctx = createContext({
    state: defaultValue,
    update: defaultUpdate,
  });
  function Provider(props: React.PropsWithChildren<{}>) {
    const [state, update] = useState(defaultValue);
    return <ctx.Provider value={{ state, update }} {...props} />;
  }
  return [ctx, Provider] as const; // alternatively, [typeof ctx, typeof Provider]
}

const [ctx, PaymentProvider] = createCtx(PaymentState);
export const PaymentContext = ctx;

export const usePaymnetContext = () => {
  return useContext(ctx)
}
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const Route = ({ path, children }: { path: string; children: any }) => {
  const isInclude = path === window.location.pathname;
  if (isInclude) {
    return children;
  }
  return path === "*" && children;
}

const renderPages = () => {
  if (window.location.pathname === "/payment/success") {
    return <SuccessPage />
  } else if (window.location.pathname === "/payment/fail") {
    return <FailurePage />
  } else if (window.location.pathname === "/checkout") {
    return <Checkout />
  } else if (window.location.pathname === "/status") {
    return <PaymentStatus />
  } else {
    return <App />
  }
}
console.log(process.env.REACT_APP_ENV)
root.render(
  // <React.StrictMode>
  <PaymentProvider>
    <AxiosInterceptor>
      {/* <> */}
      {/* <Route path="/checkoutSample">
        <Checkout />
      </Route>
      <Route path='/checkout'>
        <App />
      </Route>
      <Route path='*'>
        <div style={{ height: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
          <h1>Page Not found</h1>
          <h1>404</h1>
        </div>
      </Route> */}
      {renderPages()}
      <SystemMessage />
      {/* </> */}
    </AxiosInterceptor >
  </PaymentProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
